// JS file for PublicationItem
